// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"AccessPage_buttonWrapper__2yn0B","ihpLoginBtn":"AccessPage_ihpLoginBtn__1Bpkl","nonIhpLoginBtn":"AccessPage_nonIhpLoginBtn__13fR4"};